export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
  badgeClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: '150 Drawing Exercises Ready to Teach',
    value: '15',
    desc: 'A complete bank of exercises: line drills, observation, construction, perspective, value, composition, gesture, figure, anatomy, rendering—with timing, cues, corrections, and variations.',
    benefit: 'No preparation needed. Open, choose, teach.',
    badgeClass: 'bg-terracotta text-paper',
  },
  {
    id: '2',
    title: 'Drawing Correction Library & Teacher Signals',
    value: '12',
    desc: 'Professional signals ready to say and practical corrections for construction, perspective, proportion, value, rendering, composition, and more.',
    benefit: 'The words are already there. Just say them.',
    badgeClass: 'bg-burnt text-paper',
  },
  {
    id: '3',
    title: '50 Creative Drawing Projects & Creative Challenges',
    value: '12',
    desc: 'Creative projects with constraints, creative challenges, integrated projects, multi-session programs, homework, timed activities—for all levels and durations.',
    benefit: 'Have the right project before class starts.',
    badgeClass: 'bg-sand text-clay border border-warmgray',
  },
  {
    id: '4',
    title: 'Drawing Course, Workshop & Lesson Builder',
    value: '12',
    desc: 'Tools to transform the library into complete programs: 4-week courses, 6-week programs, 8-week programs, workshops, private lessons, mixed-level adaptations.',
    benefit: 'Open, build, launch—without guessing the structure.',
    badgeClass: 'bg-clay text-paper',
  },
  {
    id: '5',
    title: 'Drawing Rescue Vault: Emergency Class Solutions',
    value: '12',
    desc: "Emergency solutions for when class doesn't go as planned: triage systems, class resets, short fillers, replacement activities, low-material alternatives, decision trees.",
    benefit: 'When something breaks, you have the solution.',
    badgeClass: 'bg-terracotta-deep text-paper',
  },
]
